import { NavigationHandler } from '../navigation/types';

export const navigationHandler: NavigationHandler = (_, __) => {
  return new Promise<boolean>((resolve) => {
    resolve(true);
  });
};
